import { ClassementFardeChemise } from './classement-farde-chemise';
import { FolderClassificationDetails } from './classeur';

export class Chemise {
  accesRestreint: boolean;
  archive: boolean;
  archiveDate: number;
  classement: ClassementFardeChemise;
  classementAffine: string;
  classementId: number;
  id: number;
  localisation: string;
  remarques: string;
  serviceIds: number[];
  serviceProprietaireId: number;
  description?: string;
}

export class BasicFolderForAdvancedSearch {
  accesRestreint?: boolean;
  affine?: string;
  ancienNbr?: string;
  archived?: boolean;
  description?: string;
  id?: number;
  localisation?: string;
  partage?: boolean;
  remarques?: string;
}

export class FolderClassificationDetailsBinder {
  id: number;
  description: string;
  localisation: string;
  remarques: string;
  accesRestreint: boolean;
  affine: string;
  ancienNbr: string;
  partage: boolean;
  archived: boolean;
  classementAffine: string;
}
export class FolderClassificationDetailsChildren {
  label: string;
  labelLowercase: string;
  data: number;
  classementId: number;
  classeurId: number;
  archived: boolean;
  type: string;
  remarques: string;
  accesRestreint: boolean;
  classementAffine: string;
  localisation: string;
  key: number;

  parent?: FolderClassificationDetails;
}
